<template>
    <div class="project">
        <el-menu theme="dark" class="el-menu-demo" mode="horizontal" :default-active="activeIndex" router>
            <!--<router-link to="/home/pharmacy/nowStock">-->
            <el-menu-item index="/home/pharmacy/nowStock">当前库存</el-menu-item>
            <!--</router-link>-->
            <!--<router-link to="/home/pharmacy/outHouse">-->
            <el-menu-item index="/home/pharmacy/outSummary">出库汇总</el-menu-item>

            <el-menu-item index="/home/pharmacy/outHouse">出库管理</el-menu-item>
            <!--</router-link>-->
            <!--<router-link to="/home/pharmacy/intoHouse">-->
            <el-menu-item index="/home/pharmacy/intoHouse">入库管理</el-menu-item>
            <!--</router-link>-->
            <!--<router-link to="/home/pharmacy/checkStock">-->
            <el-menu-item index="/home/pharmacy/checkStock">库存盘点</el-menu-item>
            <!--</router-link>-->
        </el-menu>

        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: this.$route.path,
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// menu.vue?dd97e4f8